import React from 'react'

const Footer = () => {
  return (
    <div className='text-center p-10 mt-80 border-t dark:border-gray-700 dark:bg-gray-700 bg-gray-300 border-gray-200'><h1> 2021 Googgl,Inc</h1></div>
  )
}

export default Footer